import { Layout, Section } from 'layout';
import { GpoOrdersListScreen } from 'pages/gpo-orders/screens/gpo-orders-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const GpoOrdersPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}/list`} component={GpoOrdersListScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default GpoOrdersPage;
